// The pages that have a helper (the agent beside a page). Mirrors
// goapi/pkg/agenthost/pages.json, the one list; pageHelpers.test.ts fails when
// the two differ. `section` is the help/features section whose starter
// questions the helper offers before the first message.
export const PAGE_HELPERS: Array<{ key: string; title: string; section: string }> = [
  { key: 'tables', title: 'Tables', section: 'tables' },
  { key: 'editspec', title: 'Edit Spec', section: 'tables' },
  { key: 'files', title: 'Files', section: 'files' },
  { key: 'variables', title: 'Variables', section: 'variables' },
  { key: 'alerts', title: 'Alerts', section: 'alerts' },
  { key: 'dashboards', title: 'DataViz', section: 'dataviz' },
  { key: 'dashboard-view', title: 'Dashboard view', section: 'dataviz' },
  { key: 'dashboard-editor', title: 'Dashboard editor', section: 'dataviz' },
  { key: 'dashboard', title: 'Home', section: 'account' },
  { key: 'autocoder', title: 'AutoCoder', section: 'autocoder' },
  { key: 'pipeline-editor', title: 'Pipeline editor', section: 'autocoder' },
  { key: 'framework-library', title: 'Code frames', section: 'autocoder' },
  { key: 'framework-editor', title: 'Code frame editor', section: 'autocoder' },
  { key: 'tiktok-dashboard', title: 'TikTok', section: 'autocoder' },
  { key: 'storyboard', title: 'Storyboard', section: 'storyboards' },
]

/** The help/features section a page's helper belongs to (its starter questions), if the page has a helper. */
export const helperSection = (key: string): string | undefined => PAGE_HELPERS.find(h => h.key === key)?.section

/** The profile id a page's helper chat is created with. */
export const pageProfile = (key: string): string => `page-${key}`

/**
 * The Tables pane for a person below agent access (#1884): a second profile on
 * the Tables page (goapi/pkg/agenthost ProfilePageTablesInsights). It reads,
 * filters and finds tables; the server refuses it anything more. Not in
 * PAGE_HELPERS, which is the list of pages.
 */
export const TABLES_PANE_PROFILE = 'page-tables-insights'

/**
 * The page a helper chat belongs to, from its profile id: the page's title
 * ("Tables"), or undefined for a chat that is not a page helper's.
 */
export const pageHelperTitle = (profile?: string): string | undefined => {
  if (!profile?.startsWith('page-')) return undefined
  if (profile === TABLES_PANE_PROFILE) return 'Tables'
  const key = profile.slice('page-'.length)
  return PAGE_HELPERS.find(h => h.key === key)?.title ?? key
}
